export default "__VITE_ASSET__DkHsLqOu__"